<template>
  <!-- Added route condition to overcome slug errors -->
  <router-link
    ref="podcast-card"
    :data-segment-uuid="podcast_data.uuid"
    :class="{'grid': grid, 'hidden': hidden }"
    :to="type !== 'play' && redirect && !hidden
      ? (type === 'episode'
        ? `/listen/${podcast_data.season.podcast.publisher.slug}/${podcast_data.season.podcast.slug}/${podcast_data.slug}/${podcast_data.uuid}`
        : `/listen/${podcast_data.publisher.slug}/${podcast_data.slug}/${podcast_data.uuid}`)
    : $route.fullPath"
    class="podcast-card"
    @click.native="onPodcastClick(podcast_data.uuid,podcast.season_id)"
    @mouseover.native="onMouseOver"
    @mouseleave.native="onMouseLeave"
  >
    <div
      class="podcast-image"
    >
      <picture-component :src="podcast_data.display_image_url" />
      <PremiumIndicator
        v-if="isPremium"
      />
      <div
        v-if="hasHoverState"
        :class="`hover-state${firstItem ? ' first-item' : ''}${hovered ? ' hovered' : ''}${mediaSize === 'wide' ? ' wide' : ''}`"
      >
        <picture-component :src="podcast_data.display_image_url" />
        <PremiumIndicator
          v-if="isPremium"
        />
      </div>
    </div>
    <div
      v-if="mediaSize !== 'wide'"
      class="podcast-content"
    >
      <p
        v-if="type !== 'play'"
        class="podcast-title"
        data-test="title-contentitem">{{ podcast_data.title || 'Title not Available' }} </p>
      <p
        v-if="publisherName || podcast_data.publisher"
        class="publisher-name">{{ publisherName || podcast_data.publisher.name || "Publisher not available" }}</p>

      <div
        v-if="hasHoverState"
        :class="`hover-state${firstItem ? ' first-item' : ''}${hovered ? ' hovered' : ''}`"
      >
        <p class="title">{{ podcast_data.title }}</p>
        <p
          v-if="podcast_data && podcast_data.publisher"
          class="publisher"
        >
          {{ podcast_data.publisher.name }}
        </p>
        <p class="description">{{ podcast_data.description | truncate(55) }}</p>

        <el-button
          type="text"
          color="primary"
        >
          <span>EXPLORE</span>
          <i class="el-icon-caret-right el-icon-right"/>
        </el-button>
      </div>
    </div>
  </router-link>
</template>
<script>
import placeholder from '../assets/images/placeholder.png';
import Event from '../services/PlayerEvent';
import PremiumIndicator from './PremiumIndicator';

export default {
  name: 'PodcastCard',
  components: {
    PremiumIndicator,
  },
  props: {
    hasHoverState: {
      type: Boolean,
      default: false,
    },
    firstItem: {
      type: Boolean,
      default: false,
    },
    podcast: {
      type: Object,
      default: () => {},
    },
    grid: {
      type: Boolean,
      default: false,
    },
    redirect: {
      type: Boolean,
      default: true,
    },
    hidden: {
      type: Boolean,
      default: false,
    },
    selectable: {
      type: Boolean,
      default: false,
    },
    selected: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: '',
    },
    bucket: {
      type: Object,
      default: () => {},
    },
    mediaSize: {
      type: String,
      default: () => 'thumbnail',
    },
    publisherName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      hovered: false,
      isSelected: false,
      podcast_data: this.podcast,
      placeholder,
      text_limit: 40,
      podcast_title: this.$options.filters.truncate(this.podcast.title, this.text_limit),
      show_temp_title: true,
      eventProvider: new Event(),
    };
  },
  computed: {
    isPremium() {
      return this.podcast.is_exclusive;
    },
  },
  watch: {
    selected(newVal) {
      this.isSelected = newVal;
    },
    podcast(newVal) {
      this.podcast_data = newVal;
    },
  },
  mounted() {
    this.podcast_data = this.podcast;
    if (window.innerWidth <= 567) {
      this.text_limit = 20;
    } else if (window.innerWidth <= 768) {
      this.text_limit = 35;
    }

    const ctx = this;
    let isScrolling;
    this.scrollListener = function () {
      window.clearTimeout(isScrolling);
      isScrolling = setTimeout(() => {
        ctx.checkIfVisible();
      }, 66);
    };
    document.body.addEventListener('scroll', this.scrollListener);
    this.checkIfVisible();
  },
  destroyed() {
    document.body.removeEventListener('scroll', this.scrollListener);
  },
  methods: {
    checkIfVisible() {
      const viewportHeight = document.body.offsetHeight;
      const element = this.$refs['podcast-card'] ? this.$refs['podcast-card'].$el : null;
      if (element) {
        const elementRect = element.getBoundingClientRect();
        const elementPos = elementRect.top;
        const threshold = (element.offsetHeight / 3); // part of element within viewport
        const isVisible = elementPos >= (-1 * threshold) && (elementPos + threshold) <= viewportHeight;
        if (isVisible && this.podcast_data.uuid.length > 1) {
          element.classList.add('is-visible');
        }
      }
    },
    onPodcastClick() {
      if (!this.redirect || this.isMarketingPage) return;
      this.triggerSegmentEvent();
      if (this.type === 'episode') {
        this.$router.push(`/listen/${this.podcast.season.podcast.publisher.slug}/${this.podcast.season.podcast.slug}/${this.podcast.slug}/${this.podcast.uuid}`);
      } else {
        this.$router.push(`/listen/${this.podcast.publisher.slug}/${this.podcast.slug}/${this.podcast.uuid}`);
      }
    },
    triggerSegmentEvent() {
      const bucketData = { ...this.bucket };
      bucketData.items = {};

      const bucketItemData = { ...this.podcast };
      bucketItemData.item_position = this.$vnode.key;

      this.eventProvider.triggerContentSelectEvent(bucketData, bucketItemData);
    },
    onMouseOver() {
      this.hovered = true;
    },
    onMouseLeave() {
      this.hovered = false;
    },
  },
};
</script>
<style lang="scss">
@import "../assets/scss/variables.scss";
@import "../assets/scss/mixins.scss";

.podcast-card {
  height: 280px;
  margin-right:15px;
  width: 227px;
  display: block;

  .podcast-image {
    height: 227px;
    border: 1px solid $xlight-gray;
    background: #eee;
    position: relative;

    .el-progress {
      position: absolute;
      bottom: 0;
      z-index: 10;
      width: 100%;
      left: -0.5px;
    }

    .hover-state {
      position: absolute;
      top: 0;
      left: 0;

      border: 1px solid #D4D4D4;

      box-sizing: border-box;

      width: 100%;
      height: 100%;

      opacity: 0;
      z-index: 9999;
      transition: 100ms;
      transform: scale(1);
      transform-origin: 50% 100%;

      &.hovered {
        opacity: 1;
        transform: scale(1.185);
      }

      &.first-item {
        transform-origin: 0 100%;
      }

      &.wide {
        transform-origin: 50% 50%;

        &.first-item {
          transform-origin: 0 50%;
        }
      }

      @media (max-width: 768px) {
        display: none;
      }
    }
  }

  .podcast-list-wide & {
    height: 222px;
    width: 348px;

    .podcast-image {
      height: 222px;
    }

    @media (max-width: 1024px) {
      width: 243px !important;
      height: 155px !important;

      .podcast-image {
        height: 155px !important;
      }
    }

    @media (max-width: 1024px) {
      width: 243px !important;
      height: 155px !important;

      .podcast-image {
        height: 155px  !important;
      }
    }

    @media (max-width: 768px) {
      width: 246px !important;
      height: 157px !important;

      .podcast-image {
        height: 157px !important;
      }
    }

    @media (max-width: 567px) {
      width: 180px !important;
      height: 115px !important;

      .podcast-image {
        height: 115px !important;
      }
    }
  }

  .podcast-content {
    position: relative;

    .hover-state {
      position: absolute;
      top: -12px;
      left: 0;
      box-sizing: border-box;

      width: 100%;

      padding: 12px;

      opacity: 0;
      background-color: white;
      z-index: 99999;
      transition: 100ms;
      transform: scale(1);
      transform-origin: 50% 0;

      border: 1px solid #eee;
      border-top: none;

      &.hovered {
        opacity: 1;
        transform: scale(1.185);
      }

      &.first-item {
        transform-origin: 0 0;
      }

      p {
        margin: 0;
        width: 100%;

        &.title {
          font-size: 16px;
          margin-bottom: 10px;
          color: #111;
          font-weight: normal;

          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }

        &.publisher {
          font-size: 14px;
          color: #666;
          margin-top: -14px;
          margin-bottom: 10px;

          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }

        &.description {
          font-size: 13px;
          line-height: 18px;
          color: #111;
        }
      }

      button {
        font-size: 12px;
        padding-left: 0;
        padding-bottom: 0;

        display: flex;
        align-items: center;
        border-radius: 0 !important;
      }

      @media (max-width: 768px) {
        display: none;
      }
    }

    .playable {
      p {
        color: $gray;
        font-size: 12px;
        text-align: center;
        line-height: 13px;
      }
    }

    .el-progress {
      margin-top:0;
      .el-progress-bar {
         .el-progress-bar__outer {
            border-radius: 0 !important;
            background-color: $xlight-gray !important;
            .el-progress-bar__inner {
              border-radius: 0 !important;
            }
          }
      }
    }

    .podcast-title {
      text-transform: capitalize;
      margin-top: 11px;
      margin-bottom: 0 !important;
      color: $black;
      font-family: Favorit;
      text-align: center;
      font-size: 14px;
      line-height: 18px;

      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      width: 100%;
    }
    .publisher-name {
      text-transform: capitalize;
      text-align: center;
      font-family: Favorit-light;
      font-size: 14px;
      margin-top: 0 !important;
      color: $gray;
    }
  }
}

.podcast-card.grid {
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: 207px;
  margin: 0 8px 32px 8px;
  width: auto;
  height: auto;
  .podcast-image {
    height: 207px;
  }
  &.hidden {
    height: 0;
    margin-bottom: 0;
    overflow: hidden;
  }
}

@media (max-width:1024px) {
  .podcast-card:not(.grid) {
    height: 253px;
    width: 200px;
    .podcast-image {
      height: 200px;
    }
  }
  .podcast-card.grid {
    flex-basis: 172px;
    height: auto;
    width: auto;
    margin-bottom: 40px;
    .podcast-image {
      height: 172px;
    }
  }
}
@media (max-width: 768px) {
  .podcast-card:not(.grid) {
    height: 234px;
    width: 181px;
    .podcast-image {
      height: 181px;
    }
  }
  .podcast-card.grid {
    flex-basis: 162px;
    margin-bottom: 42px;
    .podcast-image {
      height: 162px;
    }
  }
}
@media (max-width: 576px) {
  .podcast-card.grid {
    flex-basis: 125px;
    .podcast-image {
      height: 125px;
    }
  }
}
@media (max-width: 375px) {
  .podcast-card:not(.grid) {
    height: 160px;
    width: 115px;
    .podcast-image {
      height: 115px;
    }
    .podcast-content {
      .podcast-title {
        margin-top: 5px !important;
        height: 36px;
        white-space: normal;
      }
      .publisher-name {
        display: none;
      }
    }
  }
  .podcast-card.grid {
    flex-basis: 92px;
    margin-bottom: 32px;
    .podcast-image {
      height: 92px;
    }
  }
}
@media (max-width: 334px) {
  .podcast-card.grid {
    margin: 0 4px 10px 4px;
  }
}
</style>



// WEBPACK FOOTER //
// app/src/components/PodcastCard.vue